/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const PanelWrapper = styled.div({
  marginTop: `-${gridSize() * 2}px`,
  paddingLeft: `${gridSize() * 2.5}px`,
  button: {
    svg: {
      color: token('color.text.information'),
    },
  },
  '> div': {
    margin: `0 auto ${gridSize()}px`,
  },
  table: {
    marginTop: `${gridSize()}px`,
  },
});

export const PanelHeader = styled.span({
  color: token('color.text.information'),
});

export const LozengeContainer = styled.span({
  paddingLeft: `${gridSize()}px`,
});
